// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"da612b08","265":"22574c25","328":"96a05a04","379":"3174abe9","605":"c48b216e","917":"c5a974d9","934":"a4e114c9","943":"fa80791b"}[chunkId] + ".chunk.js";
};